import React from 'react';
import PropTypes from 'prop-types';
import { CHILDREN_PROP_TYPES } from 'propTypes';

import LocationCardFulfillmentTypeGridItem from 'components/Location/LocationCardFulfillmentTypeGridItem';
import PrimaryCta from 'components/Buttons/PrimaryCta';

const LocationCardFulfillmentMethod = ({
  buttonLabel,
  handleButtonClick,
  isFullWidth,
  isCatering,
  buttonDataTestId,
  disableButton,
  LocationCardFulfillmentHours
}) => (
  <LocationCardFulfillmentTypeGridItem
    isFullWidth={isFullWidth}
    isCatering={isCatering}
  >
    <PrimaryCta
      fullWidth
      handleClick={handleButtonClick}
      label={buttonLabel}
      dataTestId={buttonDataTestId}
      disabled={disableButton}
    />
    {LocationCardFulfillmentHours}
  </LocationCardFulfillmentTypeGridItem>
);

LocationCardFulfillmentMethod.propTypes = {
  buttonLabel: PropTypes.string.isRequired,
  handleButtonClick: PropTypes.func.isRequired,
  isFullWidth: PropTypes.bool,
  isCatering: PropTypes.bool,
  buttonDataTestId: PropTypes.string.isRequired,
  disableButton: PropTypes.bool,
  LocationCardFulfillmentHours: CHILDREN_PROP_TYPES
};

LocationCardFulfillmentMethod.defaultProps = {
  isFullWidth: false,
  disableButton: false,
  LocationCardFulfillmentHours: null,
  isCatering: false
};

export default LocationCardFulfillmentMethod;
